import { containsSpecials } from "../../../store/actions/anonymousForms";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setPolicyTypeToggle,
  setTypeOfClaim,
  setPolicyNumber,
} from "../../../store/actions/anonymousForms";

import Letter from "../../letter/Letter";
import RadioGroup from "./RadioGroup";
import PageToggle from "../../anonymous-forms/components/PageToggle";
import AnonAutoForm from "../../anonymous-forms/AnonAutoForm";
import AnonHomeForm from "../../anonymous-forms/AnonHomeForm";
import AnonAutoGlassForm from "../../anonymous-forms/AnonAutoGlassForm";
import ClaimSentInfo from "./ClaimSentInfo";
import styles from "../AnonClaim.module.css";
import { prompt } from "../../../constants/messages";
import { formTypes } from "../../../constants/keys";
import { getLossCauses } from "../../../store/actions/forms";
import {
    alpahNumericRegex
} from "../../../utilities/validationUtilities"; 

export default function ClaimFrame() {
  const dispatch = useDispatch();
  let typeOfClaim = useSelector((state) => state.anonymousForms.typeOfClaim);
  const [formIsSelected, setFormIsSelected] = useState(false);
  let lossCauses = useSelector((state) => state.forms.lossCauses);

  const loadForm = () => {
    switch (typeOfClaim) {
      case formTypes.Auto:
      case formTypes.Vehicle:
        return <AnonAutoForm />;
      case formTypes.Home:
      case formTypes.Property:
      case formTypes.Liability:
      case formTypes.Garage:
        return <AnonHomeForm />;
      case formTypes.AutoGlass:
        return <AnonAutoGlassForm />;
      case "completed":
        return <ClaimSentInfo />;
      default:
        break;
    }
  };

  useEffect(() => {
    if (lossCauses?.length < 1) {
      dispatch(getLossCauses());
    }
  });

  return !formIsSelected ? (
    <BasicInfo
      typeOfClaim={typeOfClaim}
      setFormIsSelected={setFormIsSelected}
    />
  ) : (
    // load the form
    <>
      <div className={styles.HomeButtonDiv}>
        <button
          className={styles.homeButton}
          onClick={() => {
            setFormIsSelected(false);
          }}
        >
          Home
        </button>
      </div>
      {loadForm()}
    </>
  );
}

function BasicInfo({ typeOfClaim, setFormIsSelected }) {
  const dispatch = useDispatch();
  let policyTypeToggle = useSelector(
    (state) => state.anonymousForms.policyTypeToggle
  );
  const [policyWarning, setPolicyWarning] = useState(false);
  const [charWarning, setCharWarning] = useState(false);
  const policyNumber = useSelector(
    (state) => state.anonymousForms.policyNumber
  );
  const setClaimType = (claimType) => {
    dispatch(setTypeOfClaim(claimType));
  };

  const startClaim = () => {
    typeOfClaim !== "choosing"
      ? setFormIsSelected(true)
      : setFormIsSelected(false);
  };

  // A policy number greater than 7 characters in length will cause the Mulesoft CNG to fail.
  const setPolicy = (e) => {
    //if (containsSpecials(e.target.value)) {
    ////  setCharWarning(true);
    ////} else {
    ////  setCharWarning(false);
    ////  if (e.target.value.length > 7) {
    ////    dispatch(setPolicyNumber(e.target.value.substring(0, 7)));
    ////    setPolicyWarning(true);
    ////  } else {
    ////    setPolicyWarning(false);
    ////    dispatch(setPolicyNumber(e.target.value));
    //    //  }
      //}

      if (e.target.value) {
          if (!alpahNumericRegex.test(e.target.value)) {
             //do not dispatch
          }
          else if (e.target.value.length > 7) {
              dispatch(setPolicyNumber(e.target.value.substring(0, 7)));
          }

          else {
             
              dispatch(setPolicyNumber(e.target.value));
          }

      }
      else { //allow empty
          dispatch(setPolicyNumber(e.target.value));
      }
  };

  function handleToggleSelect(label) {
    dispatch(
      setPolicyTypeToggle(
        policyTypeToggle.map((item) => {
          if (item.label === label) {
            return { label: item.label, selected: true };
          } else {
            return { label: item.label, selected: false };
          }
        })
      )
    );
  }
  return (
    <>
      <div className={styles.greeting}>
        <div className={styles.numberDiv}>
          <Letter />
        </div>
        <div className={styles.promptBox}>{prompt}</div>
        <div className={styles.claimTypeSelector}>
          <span className={styles.label}>Your claim is:</span>
          <PageToggle
            flexDir="row"
            options={policyTypeToggle}
            handleSelect={(label) => handleToggleSelect(label)}
          />
        </div>

        <div className={styles.numberDiv}>
          <label className={styles.label} htmlFor="policyNum">
            Have a policy number? Please enter it here:
          </label>
          <input
            id="policyNum"
            className={styles.inputText}
            value={policyNumber}
            onChange={(e) => setPolicy(e)}
          />
          <div className={styles.warningDiv}>
            {policyWarning && (
              <p className={styles.policyLengthWarning}>
                {" "}
                *Policy number may not be more than 7 digits.
              </p>
            )}
            {/*{charWarning && (*/}
            {/*  <p className={styles.policyLengthWarning}>*/}
            {/*    {" "}*/}
            {/*    *Input may not contain special characters.{" "}*/}
            {/*  </p>*/}
            {/*)}*/}
          </div>
        </div>

        <RadioGroup
          setClaimType={setClaimType}
          startClaim={startClaim}
          isPersonal={policyTypeToggle[0].selected}
        />
      </div>
    </>
  );
}
